import { render, staticRenderFns } from "./FarmaciaView.vue?vue&type=template&id=6de9bdc7"
import script from "./FarmaciaView.vue?vue&type=script&lang=js"
export * from "./FarmaciaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports